import { PureComponent } from 'react';
import EmbeddedViralLink from 'viral-links-lib/embedded-viral-link/EmbeddedViralLink';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
export const ViralFrameContainer = styled.div.withConfig({
  displayName: "WidgetBranding__ViralFrameContainer"
})(["max-height:22px;min-height:22px;height:22px;"]);
class WidgetBranding extends PureComponent {
  render() {
    const {
      liveChatHref,
      lang
    } = this.props;
    const query = new URL(liveChatHref).searchParams;
    const intent = query.get('intent');
    const viralSourcePortalId = query.get('viralSourcePortalId');
    const hubs_medium = query.get('hubs_medium');
    const hubs_campaign = query.get('hubs_campaign');
    return /*#__PURE__*/_jsx(ViralFrameContainer, {
      className: "p-x-1 m-bottom-1 align-center justify-center",
      children: /*#__PURE__*/_jsx(EmbeddedViralLink, {
        linkType: "live-chat",
        langOverride: lang,
        additionalParams: {
          intent,
          viralSourcePortalId,
          hubs_medium,
          hubs_campaign
        }
      })
    });
  }
}
WidgetBranding.displayName = 'WidgetBranding';
export default WidgetBranding;